<script>
import gamepads from 'linna/services/gamepads'

import Dump from 'linna/components/Dump'

export default {

  components: {
    Dump
  },

  data () {
    return {
      gamepads
    }
  },

  computed: {

    dump () {
      return {
        mainLoopId: gamepads.mainLoopId,
        mainLoopStartTimestamp: gamepads.mainLoopStartTimestamp,
        mainLoopElapsed: gamepads.mainLoopElapsed
      }
    },

    gamepadInputs () {
      return gamepads.firstConnectedGamepadInputs || gamepads.inputs[0]
    },

    leftStickDirection () {
      return Math.atan2(this.gamepadInputs.leftStickX, this.gamepadInputs.leftStickY)
    },

    // https://answers.unity.com/questions/804075/how-to-get-overall-intensity-for-each-joystick-axi.html
    leftStickIntensity () {
      const maxMagnitude = Math.abs(this.gamepadInputs.leftStickX) > Math.abs(this.gamepadInputs.leftStickY)
        ? 1 / Math.cos(this.leftStickDirection)
        : 1 / Math.sin(this.leftStickDirection)

      const magnitude = (Math.abs(this.gamepadInputs.rightStickX) + Math.abs(this.gamepadInputs.rightStickY)) / 2

      return Math.abs(magnitude / maxMagnitude)
    },

    // FIXME: won't work - these need to be weighted based on degree
    rightStickIntensity () {
      return (
        Math.abs(this.gamepadInputs.rightStickX) +
        Math.abs(this.gamepadInputs.rightStickY
        ) / 2)
    }

  },

  methods: {

    updateInputValues () {
      return gamepads.updateInputValues()
    }

  }

}
</script>

<template>
  <div class="c-view-debug">

    <h1>
      <router-link
        :to="{
          name: 'mainMenu'
        }"
      >
        ⬅
      </router-link>

      Gamepad debugging
    </h1>

    <p>
      <button @click="updateInputValues">
        Get values
      </button>
    </p>

    <dump :value="dump" />

    <div class="c-view-debug-buttons">
      <div
        v-for="(value, key) in inputs"
        :key="key"
        :class="{
          'c-view-debug-button-pressed': !!value,
          'c-view-debug-button-not-pressed': !value
        }"
        :style="{
          backgroundColor: 'rgba(0, 0, 0, ' + Math.abs(value * 0.5) + ')'
        }"
        class="c-view-debug-button"
      >
        {{ key }}: {{ value }}
      </div>
    </div>
  </div>
</template>

<style lang="scss">

.c-view-debug {
  @include buffer;
}

.c-view-debug-buttons {
  display: flex;
  flex-wrap: wrap;
}

.c-view-debug-button {
  padding: 0.5em;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  width: 25%;
  box-sizing: border-box;
}

.c-view-debug-button-not-pressed {
  opacity: 0.5;
}

.c-view-debug-button-pressed {
  border-color: #666;
}

</style>
